import { CREDIT_RISK_LEVEL } from '../../../../models/RiskProducts';
import { CreditRiskLevelEstimate } from './CreChart.types';

export const EUROPE_REGION = 'EU';

export const FINANCIAL_NON_EURO_CRL: CreditRiskLevelEstimate[] = [
  {
    value: 0.015,
    level: CREDIT_RISK_LEVEL.LOW,
  },
  {
    value: 0.15,
    level: CREDIT_RISK_LEVEL.MODERATE,
  },
  {
    value: 1,
    level: CREDIT_RISK_LEVEL.HIGH,
  },
  {
    value: 5,
    level: CREDIT_RISK_LEVEL.VERY_HIGH,
  },
];

export const FINANCIAL_EURO_CRL: CreditRiskLevelEstimate[] = [
  {
    value: 0.25,
    level: CREDIT_RISK_LEVEL.LOW,
  },
  {
    value: 1,
    level: CREDIT_RISK_LEVEL.MODERATE,
  },
  {
    value: 3,
    level: CREDIT_RISK_LEVEL.HIGH,
  },
  {
    value: 6,
    level: CREDIT_RISK_LEVEL.VERY_HIGH,
  },
];

export const NON_FINANCIAL_CRL: CreditRiskLevelEstimate[] = [
  {
    value: 0.1,
    level: CREDIT_RISK_LEVEL.LOW,
  },
  {
    value: 0.5,
    level: CREDIT_RISK_LEVEL.MODERATE,
  },
  {
    value: 3,
    level: CREDIT_RISK_LEVEL.HIGH,
  },
  {
    value: 10,
    level: CREDIT_RISK_LEVEL.VERY_HIGH,
  },
];
